module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_vm._t("default"), _c('h1', {
    staticClass: "card__header"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._t("eventRequest"), _c('div', {
    staticClass: "card__content"
  }, [(_vm.$slots.slider) ? _c('div', {
    staticClass: "card__slider"
  }, [_vm._t("badges"), _vm._t("slider")], 2) : _vm._e(), _c('aside', {
    staticClass: "card__sidebar"
  }, [_c('sidebar', _vm._b({
    on: {
      "show-place": _vm.showPlace
    }
  }, 'sidebar', _vm.sidebarProps, false), [_vm._t("sidebarButtonPlace", null, {
    "slot": "buttonPlace"
  }), _vm._t("sidebarAfterButton", null, {
    "slot": "afterButton"
  })], 2)], 1), _c('main', {
    staticClass: "card__maim"
  }, [_c('div', {
    staticClass: "card__tabs"
  }, [_c('tabs', {
    staticClass: "tabs-container",
    attrs: {
      "tabs": _vm.navResult,
      "current-component": _vm.currentView
    },
    on: {
      "tab-changed": _vm.tabHandler
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c(props.currentView, _vm._b({
          tag: "component",
          staticClass: "tabs-component"
        }, 'component', props.currentProps, false), [(props.currentView === "Reviews") ? _vm._t("compReview", null, {
          "slot": "reviewsWrap"
        }) : _vm._e(), (props.currentView === "Questionnaire") ? _vm._t("questionnaire", null, {
          "slot": "questionnaireWrap"
        }) : _vm._e()], 2)]
      }
    }], null, true)
  })], 1), (_vm.$slots.footer) ? _c('div', {
    staticClass: "card__footer"
  }, [_vm._t("footer")], 2) : _vm._e()])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-168269b8","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/card/Card.vue
// module id = 8c1cfd623acd7867fbc4
// module chunks = 6